<template>
	<div class="index">
		<div class="layui-layout layui-layout-admin" style="display: flex;flex-wrap: wrap;">
			<div class="layui-header zt_color layui-row" style="width:100%;box-shadow: 0 1px 3px 0px rgba(0,0,0,0.3);position: fixed;top: 0;left: 0;">
				<div class="layui-logo f_row al_itm pointer" style="color:#fff;width:auto;">
					<img src="../assets/logo.png" style="margin: 0 10px 0 20px;" height="40" width="40" alt="">
					<span class="px20">桃琼之瑶SMT活动钢网区域战略合作伙伴</span>
				</div>
				<ul class="layui-nav layui-layout-right"></ul>
			</div>
			<div class="layui-side layui-bg-gray" style="padding-top: 60px;">
				<div class="layui-side-scroll">
					<ul class="layui-nav layui-nav-tree layui-nav-side" style="padding-top: 60px;box-sizing: border-box;">
						<li class="layui-nav-item" :class="active == index ? 'layui-this' : ''" v-for="(item,index) in tabList" @click="onTabQuery(index)">
							<a href="javascript:;" style="text-align: left;"><i class="layui-icon layui-icon-survey" style="margin-right: 10px;position: relative;top: 2px;"></i>{{item.title}}</a>
						</li>
					</ul>
				</div>
			</div>
			<div style="flex: 1;padding-top: 60px;padding-bottom: 50px;">
				<div class="white" v-if="show">
					<div class="row">
						<a href="javascript:;" @click="content = false;">疑问解答</a> /
						<a href="javascript:;" @click="content = false;">{{tabList[active].title}}</a>
					</div>
					<div class="content" v-if="!content">
						<div v-for="(item,index) in queryList" @click="getQuestionDetail(item.id)">
							<a href="javascript:;" class="item"><span style="display:inline-block ;width: 30px;text-align: right;">{{index+1}}.</span> {{item.title}}</a>
						</div>
					</div>
					<div class="content-body" v-if="content">
						<div class="title">{{detail.title}}</div>
						<p class="time">{{detail.time}}</p>
						<div class="content-text" v-html="detail.content"></div>
					</div>
					<div class="layui-footer align_center zt_color f_row al_itm jc_ct" style="left:0;color:#fff;z-index: 1000;">
						<span>© 桃琼之瑶SMT活动钢网</span>
					</div>
				</div>
			</div>
		</div>
		<div id="qrCode" v-if="qrcode">
			<i class="el-icon-error close" @click.stop="onCloseQrCode"></i>
			<div id="QQ">
				<a target='_blank' href='http://wpa.qq.com/msgrd?v=3&amp;site=qq&amp;menu=yes&amp;uin=2951682271' title='在线即时交谈'><i class="layui-icon layui-icon-login-qq"></i>在线客服</a>
			</div>
			<img src="../assets/qrcode.png" title="打开微信扫一扫，关注公众号绑定手机号接收消息推送" />
			<p style="font-size: 12px;">扫码关注微信公众号<br />绑定账号接收消息提醒</p>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'index',
		data() {
			return {
				show: false,
				content: false,
				qrcode: true,
				tabList: [],
				queryList: [],
				active: 0,
				detail: ''
			}
		},
		mounted() {
			document.title = "疑问解答";
			this.getQuestionCategory();
		},
		methods: {
			getQuestionCategory() {
				let _this = this;
				api.getQuestionCategory({

				}).then((res) => {
					if(res.code == 1) {
						_this.tabList = res.data;
						_this.show = true;
						_this.onQueryList();
					}
				})
			},
			onTabQuery(ind) {
				this.active = ind;
				this.content = false;
				this.onQueryList();
			},
			onQueryList() {
				let _this = this;
				api.getQuestionList({
					category_id: this.tabList[this.active].id
				}).then((res) => {
					if(res.code == 1) {
						_this.queryList = res.data;
					}
				})
			},
			getQuestionDetail(id) {
				let _this = this;
				api.getQuestionDetail({
					question_id: id
				}).then((res) => {
					if(res.code == 1) {
						let t = new Date(res.data.updatetime * 1000);
						let yy = t.getFullYear();
						let mm = t.getMonth() + 1;
						let dd = t.getDate();
						let h = t.getHours();
						let m = t.getMinutes();
						res.data.time = yy + '-' + mm + '-' + dd + ' ' + h + ':' + m;
						_this.detail = res.data;
						_this.content = true;
					}
				})
			},
			onCloseQrCode() {
				this.qrcode = false;
			},
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.content-body {
		padding: 30px 30px 30px 15px;
		font-size: 14px;
		line-height: 30px;
	}
	
	.content-body .title {
		font-size: 20px;
		text-align: center;
		line-height: 40px;
		font-weight: bold;
	}
	
	.content-body .time {
		color: #999;
		text-align: right;
	}
	
	.content {
		padding: 30px 30px 30px 15px;
		font-size: 14px;
		line-height: 30px;
		display: flex;
		flex-direction: column;
	}
	
	.content .item {
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	
	.content .item:hover {
		text-decoration: underline;
	}
	
	.layui-side-scroll .layui-nav-item:last-child{
		margin-bottom: 50px;
	}
	
	.white {
		padding: 30px;
	}
	
	#qrCode {
		width: 120px;
		position: fixed;
		bottom: 80px;
		right: 0;
		background: #FFFFFF;
		border-radius: 5px;
		padding: 5px;
		z-index: 10000;
		text-align: center;
		box-shadow: 0 0 5px 1px rgba(0, 0, 0, 0.3);
		cursor: pointer;
	}
	
	#qrCode #QQ {
		width: 120px;
		height: 40px;
		color: #FFFFFF;
		background: #4876FF;
		border-radius: 5px;
		margin-bottom: 10px;
		box-sizing: border-box;
		padding: 0 10px;
	}
	
	#qrCode #QQ a {
		display: flex;
		align-items: center;
		height: 40px;
		line-height: 40px;
		color: #FFFFFF;
	}
	
	#qrCode #QQ a i {
		font-size: 30px;
		margin-right: 10px;
	}
	
	#qrCode img {
		width: 120px;
		height: 120px;
	}
	
	#qrCode .close {
		position: absolute;
		bottom: -30px;
		left: 50%;
		transform: translateX(-50%);
		font-size: 24px;
	}
</style>


// WEBPACK FOOTER //
// src/components/help.vue